module.exports = __webpack_public_path__ + "media/images/tables/1side-3e4c8b8550de27ea2d134f5d21abe294.png";